import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {PressureConfig, PressureConfigJson} from './pressure-config';
import {MeasureTypeEnum} from '../state/measure-type.enum';

export type MeasureTypePressureConfigJson = {
  baseline: PressureConfigJson;
  infusion: PressureConfigJson;
};

export class MeasureTypePressureConfig implements JsonConfigInterface<MeasureTypePressureConfigJson> {

  public readonly baseline: PressureConfig = new PressureConfig();
  public readonly infusion: PressureConfig = new PressureConfig();

  constructor(json?: MeasureTypePressureConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public deserializeJson(json: MeasureTypePressureConfigJson): void {
    this.baseline.deserializeJson(json.baseline);
    this.infusion.deserializeJson(json.infusion);
  }

  public fromType(type: MeasureTypeEnum): PressureConfig {
    switch (type) {
      case MeasureTypeEnum.BASELINE:
        return this.baseline;
      case MeasureTypeEnum.INFUSION_TEST:
        return this.infusion;
      default:
        throw new Error(`Unhandled measure type '${Utils.enumName(type, MeasureTypeEnum)}'`);
    }
  }
}
